"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class ContactGroupModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            createdDate: 'CreatedDate',
            name: 'Name',
            numberOfMembers: 'McLabs2__Num_Group_Members__c',
            numberOfMembersNew: 'McLabs2__Num_Groups_Members__c',
            ownerId: 'OwnerId'
        };
    }
}
exports.ContactGroupModel = ContactGroupModel;
//# sourceMappingURL=contact-group.model.js.map